<main class="p-4 p-xxl-5">
  <section class="card border rounded-3 overflow-hidden">
    <div class="card-header bg-white d-flex align-items-center justify-content-between flex-wrap gap-3 py-3 px-4">
      <div class="d-inline-flex align-items-center flex-wrap border rounded-2 bg-light p-1" role="group" aria-label="Agreement filters">
        <button
          v-for="filter in filters"
          :key="filter.label"
          type="button"
          @click="set_active_filter(filter.tone)"
          :class="[
            'btn btn-sm d-inline-flex align-items-center gap-2 px-3 py-1',
            active_filter === filter.tone ? 'bg-white border shadow-sm fw-semibold' : 'border-0 bg-transparent'
          ]"
        >
          <span>{{ filter.label }}</span>
          <span v-if="filter.count">{{ filter.count }}</span>
        </button>
      </div>

      <div class="d-flex align-items-center justify-content-end flex-wrap gap-2">
        <label class="onboarding-queue-search d-inline-flex align-items-center">
          <i class="bi bi-search" aria-hidden="true"></i>
          <input v-model="table_search" type="search" placeholder="Search table" @input="reset_table_page">
        </label>
        <button type="button" class="btn btn-sm bg-white border rounded-2 d-inline-flex align-items-center gap-2 fw-semibold px-3 py-1">
          <i class="bi bi-funnel"></i>
          <span>Filters</span>
        </button>
        <button type="button" class="btn btn-sm bg-white border rounded-2 d-inline-flex align-items-center gap-2 fw-semibold px-3 py-1">
          <i class="bi bi-download"></i>
          <span>Export</span>
        </button>
      </div>
    </div>

    <div class="table-responsive">
      <table class="table align-middle mb-0">
        <thead class="table-light">
          <tr>
            <th class="text-uppercase text-muted small fw-semibold py-3 ps-4">Agreement</th>
            <th class="text-uppercase text-muted small fw-semibold py-3">Onboarded Entity</th>
            <th class="text-uppercase text-muted small fw-semibold py-3">Counterparty</th>
            <th class="text-uppercase text-muted small fw-semibold py-3">Status</th>
            <th class="text-uppercase text-muted small fw-semibold py-3">Blocks?</th>
            <th class="text-uppercase text-muted small fw-semibold py-3 pe-4">Action</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="item in paginated_agreements"
            :key="`${item.agreement}-${item.case_name}`"
            class="cursor-pointer"
            tabindex="0"
            @click="open_agreement_detail(item)"
            @keyup.enter="open_agreement_detail(item)"
          >
            <td class="ps-4 fw-bold text-black py-3">{{ item.agreement }}</td>
            <td class="py-3">{{ item.case_name }}</td>
            <td class="py-3">{{ item.counterparty }}</td>
            <td class="py-3">
              <span
                v-if="item.status !== '-'"
                :class="['badge rounded-pill fw-normal', status_badge_class(item.status_tone)]"
              >
                {{ item.status }}
              </span>
              <span v-else>-</span>
            </td>
            <td class="py-3">{{ item.blocks }}</td>
            <td class="pe-4 py-3 onboarding-text-navy">
              <button
                v-if="item.action !== '-'"
                type="button"
                class="btn btn-link p-0 text-decoration-none fw-semibold onboarding-text-navy"
               
              >
                {{ item.action }}
              </button>
              <span v-else>-</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <TablePagination
      :page="table_page"
      :page-size="table_page_size"
      :page-size-options="table_page_size_options"
      :total-rows="table_total_rows"
      :page-start="table_page_start"
      :page-end="table_page_end"
      :total-pages="table_total_pages"
      @update:page="set_table_page"
      @update:page-size="set_table_page_size"
    />
  </section>

  <div
    v-if="selected_agreement"
    class="onboarding-case-detail-backdrop"
    @click="close_agreement_detail"
  ></div>

  <aside
    v-if="selected_agreement"
    :class="['onboarding-case-detail-drawer bg-white shadow-lg', { 'is-fullscreen': is_detail_fullscreen }]"
  >
    <header class="border-bottom p-4">
      <div class="d-flex align-items-start justify-content-between gap-3">
        <div class="min-w-0">
          <div class="text-uppercase text-muted fw-semibold small mb-3">{{ selected_context.eyebrow }}</div>
          <h2 class="h5 fw-bold text-black mb-2">{{ selected_context.title }}</h2>
          <p class="mb-0 text-muted">{{ selected_context.subtitle }}</p>
        </div>

        <div class="d-flex align-items-center gap-3 flex-shrink-0">
          <span :class="['badge rounded-pill fw-normal', status_badge_class(selected_context.badge_tone)]">
            <span class="me-1">&bull;</span>{{ selected_context.badge }}
          </span>
          <button
            type="button"
            class="btn btn-link text-muted p-0"
            :aria-label="is_detail_fullscreen ? 'Exit fullscreen' : 'View fullscreen'"
            :title="is_detail_fullscreen ? 'Exit fullscreen' : 'View fullscreen'"
            @click="toggle_detail_fullscreen"
          >
            <i :class="['bi', is_detail_fullscreen ? 'bi-fullscreen-exit' : 'bi-fullscreen', 'fs-5']"></i>
          </button>
          <button type="button" class="btn btn-link text-muted p-0" aria-label="Close agreement detail" @click="close_agreement_detail">
            <i class="bi bi-x-lg fs-5"></i>
          </button>
        </div>
      </div>
    </header>

    <div class="onboarding-case-detail-body p-4">
      <nav class="bg-light rounded-3 p-1 d-flex align-items-center gap-2 mb-4" aria-label="Agreement detail sections">
        <button
          v-for="tab in computed_detail_tabs"
          :key="tab.id"
          type="button"
          :class="[
            'btn btn-sm flex-fill d-inline-flex align-items-center justify-content-center gap-2',
            active_detail_tab === tab.id ? 'bg-white border shadow-sm fw-semibold' : 'border-0 bg-transparent'
          ]"
          @click="set_detail_tab(tab.id)"
        >
          <i :class="['bi', tab.icon]"></i>
          <span>{{ tab.label }}</span>
          <span v-if="tab.count" class="badge rounded-pill text-bg-danger">{{ tab.count }}</span>
        </button>
      </nav>
      <section class="border rounded-3 bg-light-subtle px-4 py-3 mb-4" aria-label="Current agreement action">
        <div class="text-uppercase text-muted fw-semibold small mb-2">Required Action</div>
        <p class="text-muted mb-0">{{ current_detail_action_copy() }}</p>
      </section>
      <section v-if="active_detail_tab === 'summary'">
        <dl class="row g-0 mb-4">
          <template v-for="row in selected_context.summary" :key="row[0]">
            <dt class="col-4 text-muted fw-normal mb-3">{{ row[0] }}</dt>
            <dd class="col-8 fw-semibold mb-3">{{ row[1] }}</dd>
          </template>
        </dl>

        <section class="mb-4">
          <div class="text-uppercase text-muted fw-semibold small mb-3">Overall readiness</div>
          <div class="d-flex align-items-center gap-3">
            <div class="progress flex-grow-1 onboarding-progress-track">
              <div
                class="progress-bar onboarding-progress-bar"
                :style="{ '--onboarding-progress-size': `${selected_context.readiness}%`, '--onboarding-progress-color': progress_bar_color(selected_context.progress_tone) }"
              ></div>
            </div>
            <span class="small fw-bold">{{ selected_context.readiness }}%</span>
          </div>
        </section>

        <section>
          <div class="text-uppercase text-muted fw-semibold small mb-3">Stage timeline</div>
          <div class="onboarding-case-timeline">
            <article
              v-for="item in selected_context.timeline"
              :key="item.title"
              :class="['onboarding-case-timeline-item', `is-${item.status}`]"
            >
              <span class="onboarding-case-timeline-icon">
                <i :class="['bi', item.icon]"></i>
              </span>
              <div>
                <div class="fw-semibold text-black">{{ item.title }}</div>
                <div class="text-muted small mt-1">{{ item.detail }}</div>
              </div>
            </article>
          </div>
        </section>
      </section>

      <section v-else-if="active_form_section">
        <div class="text-uppercase text-muted fw-semibold small mb-3">{{ active_form_section.label }}</div>
        <section
          v-for="sub_section in active_form_section.sub_sections"
          :key="sub_section.id"
          class="mb-4"
        >
          <div
            v-if="sub_section.label && sub_section.label !== active_form_section.label"
            class="text-uppercase text-muted fw-semibold small mb-3"
          >
            {{ sub_section.label }}
          </div>
          <div class="onboarding-answer-grid">
            <article
              v-for="question in sub_section.questions"
              :key="question.id"
              class="onboarding-answer-card"
            >
              <p class="onboarding-answer-card__label">{{ question.label }}</p>
              <div class="onboarding-answer-card__value">{{ question.answer }}</div>
            </article>
          </div>
        </section>
      </section>

      <section v-else-if="active_detail_tab === 'agreements'">
        <div class="d-flex align-items-center justify-content-between mb-3">
          <div class="text-uppercase text-muted fw-semibold small">Agreements & e-signing</div>
          <div class="text-uppercase text-muted fw-semibold small">{{ selected_context.signed_count }}</div>
        </div>

        <div class="d-grid gap-3">
          <article class="border rounded-3 p-3">
            <div class="d-flex align-items-start gap-3">
              <span class="rounded-3 d-inline-flex align-items-center justify-content-center bg-warning-subtle text-warning-emphasis flex-shrink-0 onboarding-icon-square-21">
                <i class="bi bi-send"></i>
              </span>
              <div class="min-w-0 flex-grow-1">
                <div class="fw-bold text-black mb-1">{{ selected_context.agreement_title }}</div>
                <div class="text-muted small">{{ selected_context.agreement_note }}</div>
              </div>
              <div class="d-flex flex-column align-items-end gap-3 flex-shrink-0">
                <span class="badge rounded-pill bg-warning-subtle text-warning-emphasis">
                  <span class="me-1">&bull;</span>Awaiting signature
                </span>
                <button
                  type="button"
                  class="btn btn-primary btn-sm d-inline-flex align-items-center gap-2"
                  @click="open_sign_modal(selected_context.agreement_title, selected_context.signatory)"
                >
                  <i class="bi bi-check2-square"></i>
                  <span>Sign now</span>
                </button>
              </div>
            </div>
          </article>

        </div>
      </section>
    </div>

    <footer class="onboarding-case-detail-footer border-top bg-white p-3 d-flex align-items-center justify-content-between gap-3">
      <button type="button" class="btn btn-link text-muted d-inline-flex align-items-center gap-2 text-decoration-none">
        <i class="bi bi-stars"></i>
        <span>Ask AI</span>
      </button>
      <div class="d-flex align-items-center gap-2">
          <button type="button" class="btn btn-outline-danger d-inline-flex align-items-center gap-2">
          <i class="bi bi-x-circle"></i>
          <span>Reject</span>
        </button>
        <button type="button" class="btn btn-outline-warning d-inline-flex align-items-center gap-2">
          <i class="bi bi-send"></i>
          <span>Request info</span>
        </button>
        <button type="button" class="btn btn-primary d-inline-flex align-items-center gap-2">
          <i class="bi bi-arrow-right"></i>
          <span>Advance stage</span>
        </button>
      </div>
    </footer>
  </aside>

  <AgreementSignModal
    :visible="sign_modal.visible"
    :agreement-title="sign_modal.agreement_title"
    :signatory-name="sign_modal.signatory_name"
    :document-id="sign_modal.document_id"
    @close="close_sign_modal"
    @signed="complete_signature"
  />
</main>
